import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

import { FormPage } from '@/components/page/FormPage';
import { OrganizationForm } from '@/features/organizations/components/OrganizationForm';

export const Route = createFileRoute('/_baseLayout/organizations/create')({
  component: OrganizationsCreatePage,
});

export function OrganizationsCreatePage() {
  const { t } = useLingui();

  return (
    <FormPage
      title={t`Create organization`}
      breadcrumbs={[
        { label: t`Organizations`, to: '/organizations' },
        { label: t`Create organization`, to: '/organizations/create' },
      ]}
    >
      <OrganizationForm />
    </FormPage>
  );
}
